import { Button, CircularProgress } from '@mui/material'
import { t } from 'i18next'
import { useEffect, useState } from 'react'

import { useGlobalContext } from '../../Shared/Contexts/GlobalContext.jsx'
import ZDialog from '../../Shared/Dialogs/ZDialog.jsx'
import { useGateways } from '../Contexts/GatewaysContext.jsx'
import GatewayForm from '../Form/GatewayForm.jsx'

const UpdateGateway = ({ open, onClose, serial, onUpdate }) => {
  const { openErrorAlert } = useGlobalContext()

  const [isValid, setIsValid] = useState(false)
  const [formData, setFormData] = useState({})
  const { useFetchGateway } = useGateways()
  const [gateway, setGateway] = useState(null)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    useFetchGateway(serial)
      .then(({ data }) => setGateway({ ...data, lat: data.position?.latitude, lng: data.position?.longitude }))
      .catch((err) => openErrorAlert({ keys: err.data.keys }))
      .finally(() => setLoading(false))
  }, [serial])

  useEffect(() => {
    if (gateway) {
      setFormData(gateway)
    }
  }, [gateway])

  const handleUpdate = () => {
    if (!isValid) return

    const payload = {
      ...formData,
      lat: parseFloat(formData.lat),
      lng: parseFloat(formData.lng),
      wmbusId: formData.wmbusId ? formData.wmbusId : null,
      antennaLora: formData.antennaLora ? formData.antennaLora : null,
      antennaWmbus: formData.antennaWmbus ? formData.antennaWmbus : null,
      connectivity: formData.connectivity ? formData.connectivity : null,
      ...(formData.ip ? { ip: formData.ip } : {})
    }

    onUpdate(serial, payload)
  }

  const handleClose = () => {
    setFormData({})
    setIsValid(false)
    onClose()
  }

  return (
    <ZDialog
      isOpen={open}
      onClose={handleClose}
      maxWidth="md"
      title={t('gateways.updateGateway')}
      content={
        loading ? (
          <CircularProgress />
        ) : (
          <GatewayForm
            mode="update"
            initialData={gateway}
            setIsValid={setIsValid}
            onChange={setFormData}
          />
        )
      }
      actions={
        <Button
          id='gateway-modal-button-update'
          onClick={handleUpdate}
          variant="contained"
          disabled={!isValid || loading}
        >
          {t('common.update')}
        </Button>
      }
    />
  )
}

export default UpdateGateway
